import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  BaseDialogActionData,
  ButtonColor,
  HorizontalListData,
  SimpleHorizontalListWidgetConfigData,
} from 'common';
import { LoanFundedDialogAdapter } from './loan-funded-dialog.data';
import { AppSettings } from '../../../../src/app.settings';
import { SharedActionKey } from '../../shared/models/shared.model';
import { LoanData } from '../domain/models/loan.model';

@Component({
    selector: 'ifp-loan-funded-dialog',
    templateUrl: './loan-funded-dialog.component.html',
    providers: [LoanFundedDialogAdapter],
    standalone: false
})
export class LoanFundedDialogComponent {
  actions: BaseDialogActionData[] = [];

  contactPhone: string;
  listItems: HorizontalListData[];
  listWidgetConfig: SimpleHorizontalListWidgetConfigData;

  constructor(
    private readonly dialogRef: MatDialogRef<LoanFundedDialogComponent>,
    private readonly settings: AppSettings,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly adapter: LoanFundedDialogAdapter,
  ) {
    this.contactPhone = this.settings.if.contact.phone;
    this.listItems = this.adapter.adaptListData(this.data.loan);
    this.listWidgetConfig = this.adapter.adaptWidgetConfigData();
    this.initActions();
  }

  private initActions(): void {
    if (this.data.bankIntegrationRequired) {
      this.actions = [
        { actionKey: SharedActionKey.LinkYourBank, label: 'Link your bank', buttonColor: ButtonColor.Primary },
      ];
      return;
    }
    this.actions = [{ actionKey: SharedActionKey.Ok, label: 'Ok', buttonColor: ButtonColor.Primary }];
  }

  static show(
    dialog: MatDialog,
    loan: LoanData,
    bankIntegrationRequired: boolean,
    disbursedAmount: number,
  ): Observable<any> {
    return dialog
      .open(LoanFundedDialogComponent, {
        width: '510px',
        data: {
          loan: loan,
          bankIntegrationRequired: bankIntegrationRequired,
          disbursedAmount: disbursedAmount,
        },
        closeOnNavigation: true,
      })
      .afterClosed();
  }

  onActionClicked(actionData: BaseDialogActionData): void {
    this.dialogRef.close(actionData.actionKey);
  }
}
